import React, { createContext, useContext } from 'react';
import { FontProvider } from '../FontProvider';
import { ReportThemeContainer } from './ReportThemeContainer';
import { MenuItemProvider } from './MenuItemProvider';
const ElementTypeContext = createContext('report');
const ElementTypeProvider = ElementTypeContext.Provider;
export function useElementType() {
    return useContext(ElementTypeContext);
}
export const ReportContainerProviders = (props) => {
    return (React.createElement(FontProvider, { url: props.url, authenticationType: props.authenticationType },
        React.createElement(MenuItemProvider, { menuItemProvider: props.menuItemProvider },
            React.createElement(ReportThemeContainer, { url: props.url, packageUri: props.packageUri, themeOverrides: props.themeOverrides },
                React.createElement(ElementTypeProvider, { value: props.elementType }, props.children)))));
};
